/* tslint:disable */
/* eslint-disable */
export enum ServiceordreKildeEnumDto {
  Egis = 'EGIS',
  G4S = 'G4S',
  PartnerOprettet = 'PartnerOprettet',
  KonverteretEftersyn = 'KonverteretEftersyn',
  Valeur = 'Valeur'
}
